<form-tariff [data]="data"></form-tariff>
